export const LOADING_STATUSES: string[] = [
  "Pushing and pulling levers...",
  "Crossing T's and dotting I's...",
  "Compiling beautiful document...",
  "Hot off the press. Your PDF is ready!",
];

export const TIMEOUT: number = 3000;
